import type { AppDefinition } from '../types';

import { CardBack } from './CardBack';
import { CardFront } from './CardFront';
import type { AdjetivoPayload } from './types';

/**
 * Adjetivos — adjectives and adverbs, and how they agree.
 *
 * The Portuguese mirror of the German Adjectives & adverbs deck. The card back
 * shows the four agreement forms with the endings picked out, and says plainly
 * when there are none: the mistake a German speaker makes here is inventing a
 * feminine for `grande`, and only the card that says "there is no feminine"
 * prevents it.
 *
 * The forms are derived at seed time rather than authored, so they cannot
 * disagree with the word on the front.
 */
export const adjetivosApp: AppDefinition<AdjetivoPayload> = {
  id: 'adjetivos',
  display_name: 'Adjetivos',
  CardFront,
  CardBack,
};
